import React, { useState, useEffect } from "react";
import { Modal,Row, Col, Form, Button, Table } from "react-bootstrap";
import axios from "axios";
import configData from "../config.json";
import modulesData from "../utils/modules.json";
import * as Icon from 'react-bootstrap-icons';


// Sample modules (you can replace with API)
// const modulesData = {
//   MIS: {
//     title: "MIS System",
//     menus: [
//       { formID: 1, formName: "DASHBOARD" },
//       { formID: 2, formName: "REPORTS" }
//     ]
//   },
//   HRIS: {
//     title: "HR System",
//     menus: [
//       { formID: 3, formName: "PMIS" },
//       { formID: 4, formName: "ATTENDANCE" }
//     ]
//   }
// };

const UserSettings=()=> {

  const [inputData,setInputData]=useState({
    regName: "",
    regEmail: "",
    passcode: "",
    branchID: "",
    userType: "U",
    status: "A",
    modules: ""
  });
  const [branchList,setBranchList]=useState([]);
  const [userList,setuserList]=useState();
  const [opeType,setopeType]=useState("");
  const [privileges,setPrivileges] = useState([]);

  // ---------------- MODULE SELECTION ----------------
  const [selectedModules, setSelectedModules] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [editUserID,setEditUserID]=useState("");


  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(`${configData.SERVER_URL}/branches` );
        setBranchList(response.data || []);

        const res = await axios.get(`${configData.SERVER_URL}/users`);
        setuserList(res.data || []);
      } catch (error) {
        console.error("Syatem Error:", error);
      }
    };

    getData();
  }, []);

  const handlePrivilegeChange = (index, field, value) => {
  const updated = [...privileges];

  updated[index] = {
    ...updated[index],
    [field]: value
  };

  setPrivileges(updated);
};

  const resetInputData=()=>{
    setInputData({
        regName: "",
        regEmail: "",
        passcode:"",
        branchID:"",
        userType: "U",
        status: "A",
        modules: "",
    }); 
    setSelectedModules([]);
    setopeType('I');
  }

  const setUser=async(data)=>{
    setopeType('U');

    const modulesArray = data.modules
    ? data.modules.split(',').map(m => m.trim())
    : [];

    setSelectedModules(modulesArray);

    setInputData({
        id:data.id||"",
        regName: data.regName || "",
        regEmail: data.regEmail || "",
        passcode: data.passcode || "",
        branchID: data.branchID || "",
        userType: data.userType || "",
        status:data.status || "",
        modules: modulesArray.join(','),
    });    
  }

  const handleSubmit=(e)=>{
    const {name,value}=e.target;    
    const newData = {...inputData,[name]: value}; 
    setInputData(newData);
  }

  const InsertUser=async()=>{ 
    if (
    !inputData.regName ||
    !inputData.regEmail ||
    !inputData.passcode ||
    !inputData.branchID ||
    !inputData.userType ||
    !inputData.status
    ) {
    alert("Please fill all required fields");
    return;
    }
    const branchcode =  branchList.find(b => b.id == inputData.branchID)?.branchcode;
    
    const userData = {
    ...inputData,
    branchcode:branchcode,
    modules: selectedModules.join(',')
    };

    try{
        const response = await axios.post(`${configData.SERVER_URL}/insertUser`,userData );
        alert(response.data.message);
        setuserList(response.data.data || []);
    } catch (error) {
        alert("Syatem Error:", error);
    }
    
  }

  const UpdateUser=async()=>{
    const branchcode =  branchList.find(b => b.id == inputData.branchID)?.branchcode;
    
    const userData = {
    ...inputData,
    branchcode:branchcode,
    modules: selectedModules.join(',')
    };

    try{
        const response = await axios.put(`${configData.SERVER_URL}/updatetUser`,userData );
        alert(response.data.message);
        setuserList(response.data.data || []);
    } catch (error) {
        alert("Syatem Error:", error);
    }
  }

  const userPrivilege=async(id)=>{
    setEditUserID(id);
    const response = await axios.get(`${configData.SERVER_URL}/userPrivileges/${id}/${localStorage.getItem("activeModule")}` );
    setPrivileges(response.data || []);
    handleShow();
  }

  const savePrivileges = async () => {
  try {

    const response = await axios.put( `${configData.SERVER_URL}/setuserPrivileges/${editUserID}`, privileges);
    alert("Privileges updated successfully");
    handleClose();

  } catch(error) {
    console.log(error);
  }

};

  return (
    <div className="container-fluid">

        <Modal  show={show} onHide={handleClose} dialogClassName="privilege-modal" style={{ marginTop:"100px"}}>
            <Modal.Header closeButton>
            <Modal.Title>Set user Privilege</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "75vh",  overflowY: "auto", overflowX: "auto"}}>
            <Form >
                <Table bordered hover>
                <thead>
                    <tr>
                    <th>Form Name</th>
                    <th>Enable</th>
                    <th>Insert</th>
                    <th>Update</th>
                    <th>Delete</th>
                    </tr>
                </thead>

                <tbody>
                    {privileges.map((item,index)=>(
                    <tr key={item.formID}>
                        <td>{item.formName.replaceAll("_", " ")}</td>

                        <td>
                        <Form.Check
                            checked={item.isEnabled === "Y"}
                            onChange={(e)=>
                            handlePrivilegeChange(
                                index,
                                "isEnabled",
                                e.target.checked ? "Y" : "N"
                            )
                            }
                        />
                        </td>

                        <td>
                        <Form.Check
                            checked={item.isInsert === "Y"}
                            onChange={(e)=>
                            handlePrivilegeChange(
                                index,
                                "isInsert",
                                e.target.checked ? "Y" : "N"
                            )
                            }
                        />
                        </td>

                        <td>
                        <Form.Check
                            checked={item.isUpdate === "Y"}
                            onChange={(e)=>
                            handlePrivilegeChange(
                                index,
                                "isUpdate",
                                e.target.checked ? "Y" : "N"
                            )
                            }
                        />
                        </td>

                        <td>
                        <Form.Check
                            checked={item.isDelete === "Y"}
                            onChange={(e)=>
                            handlePrivilegeChange(
                                index,
                                "isDelete",
                                e.target.checked ? "Y" : "N"
                            )
                            }
                        />
                        </td>
                    </tr>
                    ))}
                </tbody>
                </Table>

                <Button variant="primary" onClick={savePrivileges}>
                Save All
                </Button>
            </Form>
            </Modal.Body>
            <Modal.Footer closeButton></Modal.Footer>
        </Modal>

        {opeType==='I' || opeType==='U'
        ?
        <div className="card">
            <div className="card-header">{opeType==='I'?<h3>Insert User</h3>:opeType==='U'?<h3>Update User</h3>:''}</div>
            <div className="card-body">
                <Row>
                    <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>User Name</Form.Label>
                        <Form.Control type="text" id="regName" name="regName"
                        value={inputData.regName}
                        onChange={(e) => handleSubmit(e)}
                        />
                    </Form.Group>
                    </Col>

                    <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                        type="email" id="regEmail" name="regEmail"
                        value={inputData.regEmail}
                        onChange={(e) => handleSubmit(e)}
                        />
                    </Form.Group>
                    </Col>

                    <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                        type="password" id="passcode" name="passcode"
                        value={inputData.passcode}
                        onChange={(e) => handleSubmit(e)}
                        />
                    </Form.Group>
                    </Col>

                    <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Branch</Form.Label>
                        <Form.Select id="branchID" name="branchID"
                        value={inputData.branchID}
                        onChange={(e) => handleSubmit(e)}
                        >
                            <option value={0}>Select Branch</option>
                            {branchList.map((b) => (
                            <option key={b.id} value={b.id}> {b.branchcode} </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    </Col>

                    <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>User Type</Form.Label>
                        <Form.Select id="userType" name="userType"
                        value={inputData.userType}
                        onChange={(e) => handleSubmit(e)}
                        >
                        <option value='A'> Admin </option>
                        <option value='U'> User </option>
                        </Form.Select>
                    </Form.Group>
                    </Col>

                    <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Status</Form.Label>
                        <Form.Select id="status" name="status"
                        value={inputData.status}
                        onChange={(e) => handleSubmit(e)}
                        >
                        <option value='A'> Active </option>
                        <option value='I'> In-Active </option>
                        </Form.Select>
                    </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <h5>Select Modules</h5>
                    {Object.keys(modulesData).map((mod) => (
                    <Form.Check
                        key={mod}
                        type="checkbox"
                        label={mod}
                        checked={selectedModules.includes(mod)}
                        onChange={(e) => {
                        if (e.target.checked) {
                            setSelectedModules((prev) => [...prev, mod]);
                        } else {
                            setSelectedModules((prev) => prev.filter((m) => m !== mod));
                        }
                        }}
                    />
                    ))}
                </Row>
                <Row>
                {opeType==='I'
                ?
                    <div className="col-lg-2 col-md-2 col-sm-3 col-xs-6">
                    <button className="btn btn-info mt-2" onClick={InsertUser}>Insert</button>
                    </div>     
                :
                    <div className="col-lg-2 col-md-2 col-sm-3 col-xs-6">
                    <button className="btn btn-warning mt-2" onClick={UpdateUser}>Update</button>
                    </div>
                }
                </Row>
            </div>
        </div>
        :''
        }


      {/* ================= MODULE SELECTION ================= */}
        <div className="card mt-4">
            <div className="card-header">
                <h3>User List</h3>
                <button  className="btn btn-success shadow-sm" style={{float:'right'}} onClick={() => resetInputData()}> 
                    <Icon.PersonPlusFill className="me-2" />Add User
                </button>
            </div>
            <div className="card-body bg-info">
                <div className="table-responsive table-container">
                    <table className="table table-bordered table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th>Org</th>
                                <th>User Name</th>
                                <th>E-Mail</th>
                                <th>Modules</th>
                                <th>User Type</th>
                                <th>Status</th>
                                <th></th>
                            </tr>  
                        </thead>
                        <tbody>
                            {                            
                            userList && userList.length>0 && userList.map((data,index)=>(
                            <tr key={data.id}>
                                <td>{data.branchcode}</td>
                                <td>{data.regName}</td>
                                <td>{data.regEmail}</td>
                                <td>{data.modules}</td>
                                <td>{data.userType}</td>
                                <td>{data.status}</td>
                                <td>
                                    <button type="button" className="btn btn-info mt-2" style={{ borderRadius: "10px"}}
                                        onClick={() => setUser(data)}
                                    >
                                        <Icon.PencilFill />
                                    </button>
                                    {(data.modules.indexOf(localStorage.getItem("activeModule")) !== -1) 
                                        ?
                                        <button className="btn btn-info  mt-2" 
                                        onClick={()=>{userPrivilege(data.id)}}
                                        > 
                                        <Icon.PersonGear />
                                        </button>
                                        :""
                                    }
                                    
                                </td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  );
}

export default UserSettings;